import { Routes } from "@angular/router";

import { CategoryComponent } from "./components/category/category.component";
import { ProductComponent } from "./components/product/product.component";

import { CanMatchCategory } from "./matchers/category.matcher";
import { CanMatchProduct } from "./matchers/product.matcher";

// const categoryMatcher = (url: UrlSegment[]) => {
//   console.log(url);
//   return url.length === 1 || url.length === 0 ? { consumed: url } : null;
// };

export const routes: Routes = [
  // {
  //   path: "",
  //   pathMatch: "full",
  //   redirectTo: () => `/location/`,
  // },
  {
    path: ":category/:product",
    redirectTo: ({ params }) => `/location/${params.product}`,
  },

  {
    path: ":product",
    component: ProductComponent,
    canMatch: [CanMatchProduct],
  },
  {
    // matcher: categoryMatcher,
    path: ":category",
    component: CategoryComponent,
    canMatch: [CanMatchCategory],
  },

  {
    path: "**",
    redirectTo: ({ queryParams, fragment }) =>
      "/location/?" +
      new URLSearchParams(queryParams)?.toString() +
      (fragment ? `#${fragment}` : ""),
  },
];
